import React, { useRef, useState } from 'react';

const AudioPlayer = ({ title, src, children }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleReplay = () => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div>
      <h3 className="text-xl font-bold text-saffron mb-4 text-center">{title}</h3>
      <div className="flex justify-center items-center gap-3">
        <audio ref={audioRef} src={src} onEnded={() => setIsPlaying(false)} />
        
        <button
          onClick={handlePlay}
          disabled={isPlaying}
          className={`bg-gold border-2 border-saffron text-saffron p-4 rounded-full shadow-lg transition-all duration-300 ${isPlaying ? 'opacity-50 cursor-not-allowed' : 'hover:bg-saffron hover:text-gold hover:scale-110'}`}
          title="Play"
          data-testid={`play-btn-${title}`}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </button>
        
        <button
          onClick={handlePause}
          disabled={!isPlaying}
          className={`bg-gold border-2 border-saffron text-saffron p-4 rounded-full shadow-lg transition-all duration-300 ${!isPlaying ? 'opacity-50 cursor-not-allowed' : 'hover:bg-saffron hover:text-gold hover:scale-110'}`}
          title="Pause"
          data-testid={`pause-btn-${title}`}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
          </svg>
        </button>
        
        <button
          onClick={handleReplay}
          className="bg-gold border-2 border-saffron text-saffron p-4 rounded-full shadow-lg transition-all duration-300 hover:bg-saffron hover:text-gold hover:scale-110"
          title="Replay"
          data-testid={`replay-btn-${title}`}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
          </svg>
        </button>
      </div>
      {children}
    </div>
  );
};

export default AudioPlayer;
